import React, { useState } from 'react';
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline';

/**
 * Reusable Collapsible Component
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to be collapsible
 * @param {string} props.title - Title text
 * @param {string} props.description - Description/subtitle text
 * @param {React.ReactNode} props.icon - Icon to display
 * @param {boolean} props.defaultOpen - Default open state
 * @param {string} props.className - Additional classes
 */
const Collapsible = ({
  children,
  title,
  description,
  icon,
  defaultOpen = false,
  className = '',
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`bg-white rounded-lg shadow-sm border border-gray-100 ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-6 hover:bg-gray-50 transition-colors rounded-lg"
      >
        <div className="flex items-center gap-3 flex-1">
          {icon && <div className="flex-shrink-0">{icon}</div>}
          <div className="text-left flex-1">
            {title && (
              <h3 className="text-lg font-bold text-gray-900 mb-1">{title}</h3>
            )}
            {description && (
              <p className="text-sm text-gray-600">{description}</p>
            )}
          </div>
        </div>
        <div className="flex-shrink-0 ml-4">
          {isOpen ? (
            <ChevronUpIcon className="h-5 w-5 text-gray-500" />
          ) : (
            <ChevronDownIcon className="h-5 w-5 text-gray-500" />
          )}
        </div>
      </button>
      {isOpen && (
        <div className="px-6 pb-6 pt-0 border-t border-gray-100">
          {children}
        </div>
      )}
    </div>
  );
};

export default Collapsible;
